/** @format */

import * as React from "react";
import {
  Box,
  Flex,
  Image,
  Text,
  useMediaQuery,
  AspectRatio
} from "@chakra-ui/react";
import { commonInfo } from "@common/index";
import theme from "@src/style/theme";
import colors from "@src/style/colors";
import ReactCardFlip from "react-card-flip";
import DOMPurify from "dompurify";

export const Safety_KR: React.FC = () => {
  const sanitizer = DOMPurify.sanitize;
  const [flipped, setFlipped] = React.useState(
    commonInfo.security.items.map((item, index) => false)
  );
  const [isSmall] = useMediaQuery([`(max-width: ${theme.breakpoints.md})`]);
  const basePaddingX = {
    base: "20px",
    sm: "20px",
    md: "65px",
    lg: "108px"
  };
  const basePaddingY = {
    base: "50px",
    sm: "70px",
    md: "80px",
    lg: "100px"
  };
  return (
    <Flex
      position={"static"}
      width={"100%"}
      flexDirection={"column"}
      justifyContent={"center"}
      alignItems={"center"}
      backgroundColor={colors.white}
      paddingX={basePaddingX}
      paddingY={basePaddingY}
    >
      <Flex
        maxWidth={theme.breakpoints.mx}
        width={"100%"}
        flexDirection={"column"}
        justifyContent={"stretch"}
        alignItems={"center"}
        textAlign={"center"}
      >
        {/* <Text
          fontSize={{
            base: "24px",
            sm: "30px",
            md: "42px",
            lg: "52px"
          }}
          wordBreak={"keep-all"}
          fontWeight={"900"}
          color={colors.black}
          dangerouslySetInnerHTML={{
            __html: sanitizer(commonInfo.security.title)
          }}
        /> */}
        <Flex
          // mt={{
          //   base: "20px",
          //   sm: "40px",
          //   md: "42px",
          //   lg: "60px"
          // }}
          direction={"row"}
          wrap={"wrap"}
          gap={"20px"}
          justifyContent={"space-around"}
        >
          {commonInfo.security.items.map((item, index) => (
            <Box
              key={index}
              width={
                isSmall
                  ? "100%"
                  : index % 3 == 0
                  ? "100%"
                  : "calc(100%/2 - 10px)"
              }
              height={isSmall ? "350px" : "430px"}
              _hover={{ cursor: "pointer" }}
            >
              <ReactCardFlip
                isFlipped={flipped[index]}
                flipDirection="horizontal"
                containerStyle={{
                  width: "100%",
                  height: "100%"
                }}
                key={index}
              >
                <Box
                  width={"100%"}
                  height={"100%"}
                  onClick={() => {
                    setFlipped(
                      flipped.map((item, i) => (i === index ? true : item))
                    );
                  }}
                >
                  <Flex
                    direction={isSmall ? "column-reverse" : "row"}
                    width={"100%"}
                    height={"100%"}
                    justifyContent={"center"}
                    alignItems={"center"}
                    key={index}
                    borderRadius={"22px"}
                    gap={isSmall ? "0px" : "45px"}
                    backgroundColor={item.bgColor}
                    boxShadow={"dark-lg"}
                  >
                    {index % 3 == 0 && (
                      <AspectRatio
                        width={isSmall ? "30%" : "calc(430px - 70px)"}
                        ratio={1}
                      >
                        <Image src={`${item.image}`} />
                      </AspectRatio>
                    )}
                    <Text
                      color={item.textColor}
                      fontSize={{
                        base: "24px",
                        sm: "30px",
                        md: "32px"
                      }}
                      wordBreak={"keep-all"}
                      fontWeight={"700"}
                      dangerouslySetInnerHTML={{
                        __html: sanitizer(
                          isSmall ? item.title_else : item.title
                        )
                      }}
                    />
                  </Flex>
                  <Image
                    pos={"absolute"}
                    width={"36px"}
                    bottom={"36px"}
                    right={"36px"}
                    src={item.icon_front}
                  />
                </Box>
                <Box
                  width={"100%"}
                  height={"100%"}
                  onClick={() => {
                    setFlipped(
                      flipped.map((item, i) => (i === index ? false : item))
                    );
                  }}
                >
                  <Flex
                    direction={"column"}
                    width={"100%"}
                    height={"100%"}
                    justifyContent={"center"}
                    alignItems={"center"}
                    key={index}
                    borderRadius={"22px"}
                    gap={isSmall ? "0px" : "45px"}
                    backgroundColor={item.bgColor}
                    px={"48px"}
                    boxShadow={"dark-lg"}
                  >
                    <Text
                      textAlign={"start"}
                      color={item.textColor}
                      fontSize={{
                        base: "13px",
                        sm: "16px",
                        md: "22px"
                      }}
                      wordBreak={"keep-all"}
                      fontWeight={"500"}
                      dangerouslySetInnerHTML={{
                        __html: sanitizer(item.text)
                      }}
                    />
                  </Flex>
                  <Image
                    pos={"absolute"}
                    width={"36px"}
                    bottom={"36px"}
                    right={"36px"}
                    src={item.icon_back}
                  />
                </Box>
              </ReactCardFlip>
            </Box>
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Safety_KR;
